import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

// `hero`: for content at the top of a page. Uses the CSS fade (index.css) so it
// shows as soon as the prerendered HTML paints, instead of waiting for JS.
export const Reveal = ({ children, delay = 0, y = 32, className = "", hero = false }) => hero ? (
  <div className={`fade-up-in ${className}`} style={delay ? { animationDelay: `${delay}s` } : undefined}>
    {children}
  </div>
) : (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Stagger = ({ children, className = "" }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-60px" }}
    transition={{ staggerChildren: 0.09 }}
  >
    {children}
  </motion.div>
);

export const Item = ({ children, className = "" }) => (
  <motion.div
    className={className}
    variants={{
      hidden: { opacity: 0, y: 28 },
      show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: EASE } },
    }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ index, label, dark = false }) => (
  <Reveal>
    <div className="flex items-center gap-4" data-testid={`chapter-${index}`}>
      <span className="font-mono text-xs tracking-[0.3em] text-ember font-medium">
        {index}
      </span>
      <span className="h-px w-12 bg-ember" />
      <span
        className={`font-mono text-xs uppercase tracking-[0.3em] ${
          dark ? "text-obsidian/60" : "text-white/50"
        }`}
      >
        {label}
      </span>
    </div>
  </Reveal>
);

// CSS animation (index.css), so headlines reveal as soon as the prerendered
// HTML paints instead of waiting for JavaScript.
export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <span className="masked-line-in block" style={delay ? { animationDelay: `${delay}s` } : undefined}>
      {children}
    </span>
  </span>
);
